import { VariaveisAmbiente } from 'config';
import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';
import { BoletoFormModel } from 'model/api/gestao/boleto/boleto-add-form-model';
import { useSessaoAtual } from 'services/app';
import { ContaBancariaFormModel } from 'model/app/forms/master/conta-bancaria-form';

export function usePutContaBancaria() {
    const { invocarApi, ...outrasPropriedades } = useApiBase<BoletoFormModel>();
    const { getEmpresa } = useSessaoAtual();

    const empresaId = getEmpresa().Id;

    const putContaBancaria = useCallback(
        (model: ContaBancariaFormModel) =>
            invocarApi({
                method: 'PUT',
                url: `/${VariaveisAmbiente.apiVersion}/empresa/${empresaId}/conta-bancaria/${model.id}`,
                data: model,
                enviarTokenUsuario: true
            }),
        [empresaId, invocarApi],
    );
    return {
        ...outrasPropriedades,
        putContaBancaria,
    };
}